export default "__VITE_ASSET__02aecce8__"